import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=2fa0fa41&scoped=true&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=2fa0fa41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0fa41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa0fa41')) {
      api.createRecord('2fa0fa41', component.options)
    } else {
      api.reload('2fa0fa41', component.options)
    }
    module.hot.accept("./WidgetBuilder.vue?vue&type=template&id=2fa0fa41&scoped=true&", function () {
      api.rerender('2fa0fa41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/WidgetBuilder.vue"
export default component.exports